import {generatePath} from './generate-path';
import type {PathGenerationArgs} from './path-generation-args';
import type {RouteConfigPath} from './route-config-path';

// Use this to directly generate a path for any route that exists in the config
export const generateReactRouterPath = <T extends RouteConfigPath>(...args: PathGenerationArgs<T>) =>
    `${generatePath(args)}`;
